import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slice/userSlice";
import applicationSlice from "./slice/applicationSlice";
import configSlice from "./slice/configSlice";
import boardSlice from './slice/boardSlice'
// import pageSlice from "./slice/paginationSlice";

export const store = configureStore({
  reducer: {
    userSlice: userSlice,
    applicationSlice: applicationSlice,
    configSlice: configSlice,
    boardSlice:boardSlice
  },
});
